import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-entrance-guidance",
  "use": "icon-entrance-guidance-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-entrance-guidance\"><path d=\"M853.5 213.1v-2.2-1.5c0-0.7-0.7-1.5-0.7-2.2v-1.5c0-0.7-0.7-1.5-0.7-2.2 0 0 0-0.7-0.7-0.7l-2.2-2.2c-0.7-0.7-1.5-1.5-3-2.2 0 0-0.7 0-0.7-0.7-0.7-0.7-1.5-0.7-2.2-1.5-0.7 0-0.7 0-1.5-0.7-0.7 0-1.5-0.7-2.2-0.7h-8.8c-0.7 0-0.7 0-1.5 0.7-0.7 0-1.5 0.7-2.2 0.7L126 524c-7.4 3.7-11.2 11.2-10.4 18.6s6.7 14.1 14.9 16.4l267.1 58c1.5 0 3 0.7 3.7 0.7 4.5 0 8.9-1.5 12.6-4.5l401.7-357.8-9.7 447.1-308.7-87c-9.7-3-20.1 3-23.1 12.6-3 9.7 3 20.1 12.6 23.1l64.7 18.6-124.1 144.3v-148c0-10.4-8.2-18.6-18.6-18.6s-18.6 8.2-18.6 18.6V864c0 7.4 4.5 14.9 11.9 17.1 2.2 0.7 4.5 1.5 6.7 1.5 5.2 0 10.4-2.2 14.1-6.7l164.4-190.4c1.5-1.5 2.2-3.7 3-5.2L818.6 745c1.5 0.7 3.7 0.7 5.2 0.7 3.7 0 8.2-1.5 11.2-3.7 4.5-3.7 7.4-8.9 7.4-14.9l11.1-514zM396 579.1l-203.8-44.6 535.6-250.7L396 579.1z\" p-id=\"3645\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/entrance-guidance.svg
// module id = KeFE
// module chunks = 36